module.exports = __webpack_public_path__ + "img/vitara.ee85947c.svg";